import api from './api';

class PortalService {

  async getRoles() {
    const response = await api.get(`/authentication/api/groups/roles`);
    return response.data;
  }

  getGroupsByApplication (idApplication) {
    return api.get(`/authentication/api/groups/application/${idApplication}`);
  }

  saveGroup (group) {
    return api.post(`/authentication/api/groups`, group);
  }
  updateGroup (idGroup, group) {
    return api.put(`/authentication/api/groups/${idGroup}`, group);
  }
  setGroupLinks (idGroup, idLinks) {
    return api.put(`/authentication/api/groups/${idGroup}/links`, idLinks);
  }

  getApplication() {
    return api.get(`/authentication/api/applications`);
  }

  getCompanies() {
    return api.get(`/authentication/api/companies`);
  }

  getCompaniesByUserId(id) {
    return api.get(`/authentication/api/companies/getCompanyByUser/${ id }`);
  }

  getAllLinks () {
    return api.get(`/authentication/api/applications/links`);
  }

  getLinksByCompany (idCompany) {
    return api.get(`/authentication/api/applications/links/company/${idCompany}`);
  }

  setLinksByCompany (idCompany, idLinks) {
    return api.put(`/authentication/api/applications/links/company/${idCompany}`, idLinks);
  }

  getUsers() {
    return api.get(`/authentication/api/users`);
  }

  async getUser(id) {
    const response = await api.get(`/authentication/api/users/${ id }`);
    return response.data;
  }

  async saveUser(user) {
    const response = await api.post(`/authentication/api/users`, user);
    return response.data;
  }

  async modifyUser(user) {
    const response = await api.put(`/authentication/api/users`, user);
    return response.data;
  }

  async deleteUser(id) {
    const response = await api.post(`/authentication/api/users/delete/${ id }`);
    return response.data;
  }

  enablePws(pwsDto) {
    api.post(`/authentication/api/users/enable/pws`, pwsDto);
  }

  disablePws(username) {
    api.post(`/authentication/api/users/disable/pws`, username);
  }

  saveCompany(company) {
    return api.post(`/authentication/api/companies`, company);
  }

  deleteCompany(id) {
    return api.delete(`/authentication/api/companies/${ id }`);
  }

  getCapiArea(id) {
    return api.get(`/authentication/api/headzone/${ id }`);
  }

  getAgentsCapiArea(id) {
    return api.get(`/authentication/api/headzone/agents/${ id }`);
  }

  getAgentsByCompanyId(id) {
    return api.get(`/authentication/api/users/agents/${ id }`);
  }

  getCustomers(companyCode) {
    return api.get(`/authentication/api/customers/${ companyCode }`);
  }

  getCustomersByAgentId(agentId, companyId) {
    return api.get(`/authentication/api/customers/agent/${ agentId }/company/${ companyId }`);
  }

  getAssignedCustomerByAgentsId(agent, headzone, company) {
    return api.get(`/authentication/api/customers/agent/${ agent }/headzone/${ headzone }/company/${ company }`);
  }

  saveAgentsForHeadZoneAndComany(company, headzone, agents) {
    return api.post(`/authentication/api/headzone/${ headzone }/company/${ company }`, agents);
  }

  saveAgentCustomers(company, headzone, agent, customers) {
    return api.post(`/authentication/api/customers/agent/${ agent }/headzone/${ headzone }/company/${ company }`, customers);
  }

  syncPwsProducts() {
    return api.get(`/authentication/api/pws/product`);
  }

  syncPwsProductInfo() {
    return api.get(`/authentication/api/pws/info`);
  }

  syncPwsProductInfoFourth() {
    return api.get(`/authentication/api/pws/info-fourth`);
  }

  syncPwsGenericCombo() {
    return api.get(`/authentication/api/pws/combo`);
  }

  syncPwsCustomers() {
    return api.get(`/authentication/api/pws/customers`);
  }
  syncPwsOrderedProducts() {
    return api.get(`/authentication/api/pws/customer-products`);
  }
  syncPwsAvailability() {
    return api.get(`/authentication/api/pws/stock`);
  }
  syncPwsWarehouses() {
    return api.get(`/authentication/api/pws/warehouses`);
  }
  syncPwsCarriers() {
    return api.get(`/authentication/api/pws/carriers`);
  }
  syncPwsOpenOrders() {
    return api.get(`/authentication/api/pws/open-orders`);
  }

}

export default new PortalService();
